import React from 'react'
import { BackTop } from 'antd';




const CryptoGoBackTop = () => {
  return (
    <div>
       <BackTop />
    </div>
  )
}

export default CryptoGoBackTop
